import { isEmpty, isNil, pickBy } from 'ramda';
export var filterEmptyValues = function (obj) {
    return pickBy(function (val) { return !isNil(val) && !isEmpty(val); }, obj);
};
export var enumValuesFactory = function (descriptionMap) {
    return Object.entries(descriptionMap).map(function (_a) {
        var name = _a[0], description = _a[1];
        return ({
            name: name,
            description: description
        });
    });
};
